import { Col, Row } from 'react-bootstrap';
import styles from './new-user.module.scss';

export const NewUserWithAdminSubmitted = () => (
  <Row>
    <Col className={styles['submitted']}>
      <div className={styles['submitted-check']}>
        <svg width="32" height="32" viewBox="0 0 24 24" fill="none" aria-hidden>
          <path
            d="M5 12.5l4.5 4.5L19 7.5"
            stroke="#1f3d2f"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>
      <p className={`header ${styles['submitted-header']}`}>
        Your request to join has been sent to the team’s administrators
      </p>
      <p className={'subtext'}>
        Your team admins will receive an email with instructions on how to
        approve your request.
      </p>
      <div className={styles['submitted-info']} role="status">
        <svg width="16" height="16" viewBox="0 0 16 16" fill="none" aria-hidden>
          <circle cx="8" cy="8" r="7" stroke="currentColor" />
          <path d="M8 7v4" stroke="currentColor" strokeLinecap="round" />
          <circle cx="8" cy="5" r="0.75" fill="currentColor" />
        </svg>
        <span>
          Once your administrator approves your request, you can set your
          password by clicking on “Activate” link found in the sign in page
        </span>
      </div>
    </Col>
  </Row>
);
